module.exports = __webpack_public_path__ + "static/bro-video-7444b6042fdc6a4cd83dfdc734f364d1.mp4";